import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBarGraph = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 20C5.45 20 4.97933 19.8043 4.588 19.413C4.196 19.021 4 18.55 4 18V11C4 10.45 4.196 9.979 4.588 9.587C4.97933 9.19567 5.45 9 6 9C6.55 9 7.02067 9.19567 7.412 9.587C7.804 9.979 8 10.45 8 11V18C8 18.55 7.804 19.021 7.412 19.413C7.02067 19.8043 6.55 20 6 20ZM12 20C11.45 20 10.9793 19.8043 10.588 19.413C10.196 19.021 10 18.55 10 18V6C10 5.45 10.196 4.97933 10.588 4.588C10.9793 4.196 11.45 4 12 4C12.55 4 13.021 4.196 13.413 4.588C13.8043 4.97933 14 5.45 14 6V18C14 18.55 13.8043 19.021 13.413 19.413C13.021 19.8043 12.55 20 12 20ZM18 20C17.45 20 16.979 19.8043 16.587 19.413C16.1957 19.021 16 18.55 16 18V15C16 14.45 16.1957 13.979 16.587 13.587C16.979 13.1957 17.45 13 18 13C18.55 13 19.021 13.1957 19.413 13.587C19.8043 13.979 20 14.45 20 15V18C20 18.55 19.8043 19.021 19.413 19.413C19.021 19.8043 18.55 20 18 20Z",
		fill: "currentColor"
	})
});
export default SvgBarGraph;
